import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

import { HttpWrapperService, INSTRUCTIONS_FILE_NAME, LeftNavigationService } from '@craig/core';
import { InstructionsContentResponse } from './instructions-panel.interface';

@Injectable()
export class InstructionsPanelService {
    private instructionsHTMLCache: string = '';
    private readonly instructionsContent$: BehaviorSubject<string> = new BehaviorSubject<string>('');

    constructor(
        private readonly httpWrapperService: HttpWrapperService,
        private readonly leftNavigationService: LeftNavigationService
    ) {}

    set instructionsContent(content: string) {
        this.instructionsContent$.next(content);
    }

    instructionsContentChange(): Observable<string> {
        return this.instructionsContent$.asObservable();
    }

    fetchInstructionsContent(): void {
        if (this.isContentCached()) {
            this.instructionsContent = this.instructionsHTMLCache;
        } else {
            this.httpWrapperService
                .get<InstructionsContentResponse>(`/api/help/file?file_name=${INSTRUCTIONS_FILE_NAME}`)
                .pipe(map(({ body }: HttpResponse<InstructionsContentResponse>) => body))
                .subscribe({
                    next: (response: InstructionsContentResponse | null) => {
                        if (response && response.content) {
                            this.instructionsContent = response.content;
                            this.cacheContent(response.content);
                        }
                    },
                    error: () => {
                        this.leftNavigationService.showChat();
                    }
                });
        }
    }

    cacheContent(content: string): void {
        this.instructionsHTMLCache = content;
    }

    isContentCached(): boolean {
        return !!this.instructionsHTMLCache;
    }
}
